import React from "react";

export default function CustomLabelPreview({
  labelWidth,
  labelHeight,
  imagePreview,
}) {

  const previewWidth =
    labelWidth * 37.8;

  const previewHeight =
    labelHeight * 37.8;

  return (

    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >

      <div
        style={{
          width: previewWidth,
          height: previewHeight,
          border: "2px solid #000",
          overflow: "hidden",
          background: "#fff",
          position: "relative",
        }}
      >

        {imagePreview && (

          <img
            src={imagePreview}
            alt="preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />

        )}

      </div>

    </div>

  );
}